import React from 'react';
import { CheckCircle, AlertCircle } from 'lucide-react';

export const Notification = ({ notification }) => {
  if (!notification.message) return null;

  return (
    <div className={`fixed top-4 left-4 right-4 md:left-auto md:right-4 z-50 flex items-center gap-2 px-4 py-3 rounded-lg shadow-lg max-w-md animate-slide-in ${
      notification.type === 'success' 
        ? 'bg-green-900/30 text-green-300 border border-green-700' 
        : notification.type === 'error'
        ? 'bg-red-900/30 text-red-300 border border-red-700'
        : 'bg-yellow-900/30 text-yellow-300 border border-yellow-700'
    }`}>
      {notification.type === 'success' ? (
        <CheckCircle className="w-5 h-5" />
      ) : (
        <AlertCircle className="w-5 h-5" />
      )}
      <span className="text-sm font-medium">{notification.message}</span>
    </div>
  );
};